import {
	AddClientProperties,
	InfoClientProperties,
	UpdateClientInfoProperties,
} from '../../../redux/API/ClientAPIHelpers/clientProperties';

const defaultInformation = {
	firstName: '',
	lastName: '',
	nickName: '',
	dateOfBirthday: '',
	gender: '',
	email: '',
	secondaryEmail: '',
	secondaryNumber: '',
	parentPhoneNumber: '',
	address: '',
	patronymic: '',
	mbhId: '',
	insurances: [],
	branchId: '',
	otherDiagnosisCodes: '',
};

export const initialAddClientState: AddClientProperties = {
	...defaultInformation,
	status: 0,
	diagnosisCodeId: '',
	caseCoordinatorId: '',
};

export const initialInfoClientState: InfoClientProperties = {
	...defaultInformation,
	status: {
		id: 0,
		name: '',
	},
	fullName: '',
	id: '',
	defaultBcba: {
		id: '',
		email: '',
		fullName: '',
		firstName: '',
		lastName: '',
		role: {
			id: '',
			name: '',
			section: {
				id: 0,
				name: '',
			},
		},
		authorizationType: {
			id: 0,
			name: '',
		},
	},
	caseCoordinator: {
		id: '',
		email: '',
		fullName: '',
		firstName: '',
		lastName: '',
		role: {
			id: '',
			name: '',
			section: {
				id: 0,
				name: '',
			},
		},
		authorizationType: {
			id: 0,
			name: '',
		},
	},
	diagnosisCode: {
		id: '',
		name: '',
	},
	numberOfTherapist: 0,
	branches: [],
	otherDiagnosisCodes: '',
};

export const initialUpdateClientState: UpdateClientInfoProperties = {
	...initialAddClientState,
	id: '',
};
